// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOrgBalanceResponse } from './IOrgBalanceResponse';
import {
    IOrgBalanceResponseFromJSON,
    IOrgBalanceResponseFromJSONTyped,
    IOrgBalanceResponseToJSON,
    IOrgBalanceResponseToJSONTyped,
} from './IOrgBalanceResponse';

/**
 * 
 * @export
 * @interface IOrgBalancesPageResponse
 */
export interface IOrgBalancesPageResponse {
    /**
     * 
     * @type {Array<IOrgBalanceResponse>}
     * @memberof IOrgBalancesPageResponse
     */
    content: Array<IOrgBalanceResponse>;
    /**
     * 
     * @type {number}
     * @memberof IOrgBalancesPageResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof IOrgBalancesPageResponse
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof IOrgBalancesPageResponse
     */
    total_elements: number;
    /**
     * 
     * @type {number}
     * @memberof IOrgBalancesPageResponse
     */
    total_pages: number;
}

/**
 * Check if a given object implements the IOrgBalancesPageResponse interface.
 */
export function instanceOfIOrgBalancesPageResponse(value: object): value is IOrgBalancesPageResponse {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total_elements' in value) || value['total_elements'] === undefined) return false;
    if (!('total_pages' in value) || value['total_pages'] === undefined) return false;
    return true;
}

export function IOrgBalancesPageResponseFromJSON(json: any): IOrgBalancesPageResponse {
    return IOrgBalancesPageResponseFromJSONTyped(json, false);
}

export function IOrgBalancesPageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrgBalancesPageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(IOrgBalanceResponseFromJSON)),
        'page': json['page'],
        'size': json['size'],
        'total_elements': json['total_elements'],
        'total_pages': json['total_pages'],
    };
}

export function IOrgBalancesPageResponseToJSON(json: any): IOrgBalancesPageResponse {
    return IOrgBalancesPageResponseToJSONTyped(json, false);
}

export function IOrgBalancesPageResponseToJSONTyped(value?: IOrgBalancesPageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': ((value['content'] as Array<any>).map(IOrgBalanceResponseToJSON)),
        'page': value['page'],
        'size': value['size'],
        'total_elements': value['total_elements'],
        'total_pages': value['total_pages'],
    };
}

